import script from "./IfcImporterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcImporterPage.vue?vue&type=script&setup=true&lang=ts"

import "./IfcImporterPage.vue?vue&type=style&index=0&id=19a8ed29&lang=css"

const __exports__ = script;

export default __exports__